import './cdrdetails.css';
import Skeleton from '@mui/material/Skeleton';

const Loading = ({data, loading}) => {
    if (loading) {
        return <div className="px-2" style={{float: 'left'}}><Skeleton variant="rectangular" height={20} width={50} /></div>;
    } else {
        return <div className="px-2" style={{float: 'left'}}>{data}</div>;
    }
}

const VoiceCdrDetails = ({data, loading}) => {
    const cdrData = data;
    if (cdrData == undefined) {
        return <div>No data</div>;
    }
    let status = ''
    if (loading) {
        status = '';
    } else {
        status = cdrData.call_error_code == '0' ? 'status-ok' : cdrData.call_error_code == '2' ? 'status-error' : '';
    }
    return (
        <div className="cdrcard shadow-sm">
            <div className="card-body">
                <div className="sub-header d-flex">CDR Detail <Loading data={cdrData.id} loading={loading} /></div>
                <div className={`content mt-3 ${status}`}>
                    <div className="row">
                        <div className="col-md-12">
                            <table className="table-bordered w-100">
                                <tr>
                                    <td><strong>Date:</strong> <Loading data={cdrData.start_time} loading={loading} /> GMT</td>
                                    <td><strong>Time Zone:</strong> GMT</td>
                                    <td><strong>Duration:</strong> <Loading data={cdrData.call_duration} loading={loading} /></td>
                                    <td><strong>Duration(msec):</strong> <Loading data={cdrData.call_duration_fractional} loading={loading} />
                                        <br/>
                                        <strong>Connect-Time:</strong> <Loading data={cdrData.connect_time} loading={loading} /> <br/>
                                        <strong>End-Time:</strong> <Loading data={cdrData.end_time} loading={loading} /> 
                                    </td>
                                </tr>
                                <tr>
                                    <td><strong>PDD:</strong> <Loading data={cdrData.call_pdd} loading={loading} /></td>
                                    <td><strong>Call Route:</strong> <Loading data={cdrData.call_route} loading={loading} /></td>
                                    <td><strong>Status:</strong> <Loading data={cdrData.status} loading={loading} /></td>
                                    <td><strong>Status Desc:</strong> <Loading data={cdrData.status_desc} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>User ID:</strong> FIXME</td>
                                    <td><strong>Call Type:</strong> <Loading data={cdrData.call_type} loading={loading} /></td>
                                    <td><strong>Media Type:</strong> <Loading data={cdrData.media_type} loading={loading} /></td>
                                    <td><strong>Disconnect Code:</strong> <Loading data={cdrData.call_error_code} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Call Custom ID:</strong> <Loading data={cdrData.call_custid} loading={loading} /></td>
                                    <td><strong>Call Zone Data:</strong> <Loading data={cdrData.call_zone_data} loading={loading} /></td>
                                    <td><strong>Call Dest Number Type:</strong> <Loading data={cdrData.call_dest_number_type} loading={loading} /></td>
                                    <td><strong>Call Src Number Type:</strong> <Loading data={cdrData.call_src_number_type} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Orig ISDN Cause Code:</strong> <Loading data={cdrData.isdn_cause_code} loading={loading} /></td>
                                    <td><strong>MSX ID:</strong> <Loading data={cdrData.msx_id} loading={loading} /></td>
                                    <td><strong>MSX Name:</strong> <Loading data={cdrData.msx_name} loading={loading} /></td>
                                    <td><strong>Clusted ID:</strong> <Loading data={cdrData.clusted_id} loading={loading} /></td>
                                </tr>
                            </table>
                        </div>
                    </div>      
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <table className="table-bordered w-100">
                                <tr><td colspan="4" className="text-center"><strong>Origination</strong></td></tr>
                                <tr>
                                    <td><strong>Reg ID:</strong> <Loading data={cdrData.call_source_regid} loading={loading} /></td>
                                    <td><strong>IP:</strong> <Loading data={cdrData.call_source} loading={loading} /></td>
                                    <td><strong>Dialed:</strong> <Loading data={cdrData.called_party_from_src} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Src Realm Media IP1:</strong> <Loading data={cdrData.src_realm_media_ip1} loading={loading} /></td>
                                    <td><strong>Src Realm Media Port1:</strong> <Loading data={cdrData.src_realm_media_port1} loading={loading} /></td>
                                    <td><strong>Orig Port:</strong> <Loading data={cdrData.call_source_uport} loading={loading} /></td>
                                   
                                </tr>
                                <tr>
                                    <td><strong>Err ID:</strong> <Loading data={cdrData.call_error_dest_code} loading={loading} /></td>
                                    <td><strong>Err Desc:</strong> <Loading data={cdrData.call_error_dest_text} loading={loading} /></td>
                                    <td><strong>Call Gap Err:</strong> <Loading data={cdrData.call_gap_err} loading={loading} /></td>
                                   
                                </tr>
                                <tr>
                                    <td><strong>Src Private IP1:</strong> <Loading data={cdrData.src_private_ip} loading={loading} /></td>
                                    <td><strong>Src Private Port1:</strong> <Loading data={cdrData.src_private_port} loading={loading} /></td>
                                    <td><strong>Src IGRP Name:</strong> <Loading data={cdrData.src_igrp_name} loading={loading} /></td>
                                   
                                </tr>
                                <tr>
                                    <td><strong>Src P-CVI:</strong> <Loading data={cdrData.src_p_cvi} loading={loading} /></td>
                                    <td><strong>Dest P-CVI:</strong> <Loading data={cdrData.dest_p_cvi} loading={loading} /></td>
                                    <td><strong>Source Q.931 Port:</strong> <Loading data={cdrData.call_source_q931sig_port} loading={loading} /></td>
                                   
                                </tr>
                                <tr>
                                    <td><strong>Src Packets Received:</strong> <Loading data={cdrData.packets_received_on_src_leg} loading={loading} /></td>
                                    <td><strong>Src Packets Lost:</strong> <Loading data={cdrData.packets_lost_on_src_leg} loading={loading} /></td>
                                    <td><strong>Src Jitter:</strong> <Loading data={cdrData.jitter_on_src_leg} loading={loading} /></td>
                                   
                                </tr>
                                <tr>
                                    <td><strong>Src Packets Discarded:</strong> <Loading data={cdrData.packets_discarded_on_src_leg} loading={loading} /></td>
                                    <td><strong>Src R factor:</strong> <Loading data={cdrData.rfactor_on_src_leg} loading={loading} /></td>
                                    <td><strong>Src Codec:</strong> <Loading data={cdrData.codec_on_src_leg} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Src Latency:</strong> <Loading data={cdrData.latency_on_src_leg} loading={loading} /></td>
                                    <td colspan="2"><strong>Bytes fwd from Src:</strong> <Loading data={cdrData.bytes_forwarded_from_src} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>From Uri User Part:</strong> <Loading data={cdrData.from_uri_user_part} loading={loading} /></td>
                                    <td colspan="2"><strong>Paid User Part:</strong> <Loading data={cdrData.paid_uri_user_part} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Request Uri User Part:</strong> <Loading data={cdrData.request_uri_user_part} loading={loading} /></td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td><strong>Src Policed Packets:</strong> <Loading data={cdrData.policed_packets_on_src_leg} loading={loading} /></td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td><strong>Src Codec ptime:</strong> <Loading data={cdrData.src_codec_ptime} loading={loading} /></td>
                                    <td colspan="2"></td>
                                </tr>
                                <tr>
                                    <td rowspan="4"><strong>SRTP</strong></td>
                                    <td colspan="2"><strong>Src Cipher Suite:</strong> <Loading data={cdrData.src_cipher_suite} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td  colspan="2"><strong>Src Packet Outside Replay Window:</strong> <Loading data={cdrData.src_packet_outside_replay_window} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td  colspan="2"><strong>Src Packet Authentication Failure:</strong> <Loading data={cdrData.src_packet_auth_failure} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td  colspan="2"><strong>Src Packet Cipher Failure:</strong> <Loading data={cdrData.src_packet_cipher_failure} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td rowspan="2"><strong>MSRP</strong></td>
                                    <td colspan="2"><strong>Msrp Data Volume Rx Src:</strong> <Loading data={cdrData.msrp_data_volume_rx_src} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td colspan="2"><strong>Msrp Im Rx Src:</strong> <Loading data={cdrData.msrp_im_rx_src} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Call leg info1:</strong></td>
                                    <td><strong>Call leg info2:</strong></td>
                                    <td><strong>Call leg info3:</strong></td>
                                </tr>
                                <tr>
                                    <td><strong>Call leg info4:</strong></td>
                                    <td><strong>Call info1:</strong></td>
                                    <td><strong>Call info5:</strong></td>
                                </tr>
                                <tr>
                                    <td><strong>Call info6:</strong></td>
                                    <td><strong>Call info7:</strong></td>
                                </tr>
                            </table>
                        </div>

                        <div className="col-md-1 divider">&gt;&gt;</div>

                        <div className="col-md-5">
                            <table className="table-bordered w-100">
                                <tr><td colspan="4" className="text-center"><strong>Termination</strong></td></tr>
                                <tr>
                                    <td><strong>Reg ID:</strong> <Loading data={cdrData.call_dest_regid} loading={loading} /></td>
                                    <td><strong>IP:</strong> <Loading data={cdrData.call_dest} loading={loading} /></td>
                                    <td><strong>Dialed:</strong> <Loading data={cdrData.called_party_on_dest} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Dst Realm Media IP1:</strong> <Loading data={cdrData.dst_realm_media_ip1} loading={loading} /></td>
                                    <td><strong>Dst Realm Media Port1:</strong> <Loading data={cdrData.dst_realm_media_port1} loading={loading} /></td>
                                    <td><strong>Term Port:</strong> <Loading data={cdrData.call_dest_uport} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Err ID:</strong> <Loading data={cdrData.call_error_dest_code} loading={loading} /></td>
                                    <td><strong>Err Desc:</strong> <Loading data={cdrData.call_error_dest_text} loading={loading} /></td>
                                    <td><strong>Dst IGRP Name:</strong> <Loading data={cdrData.dst_igrp_name} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Dst Private IP1:</strong> <Loading data={cdrData.dest_private_ip} loading={loading} /></td>
                                    <td><strong>Dst Private Port1:</strong> <Loading data={cdrData.dest_private_port} loading={loading} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Src P-ANI:</strong> <Loading data={cdrData.ani} loading={loading} /></td>
                                    <td><strong>Dest P-ANI:</strong> <Loading data={cdrData.new_ani} loading={loading} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Dst Packets Received:</strong> <Loading data={cdrData.packets_received_on_dest_leg} loading={loading} /></td>
                                    <td><strong>Dst Packets Lost:</strong> <Loading data={cdrData.packets_lost_on_dest_leg} loading={loading} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Dst Packets Discarded:</strong> <Loading data={cdrData.packets_discarded_on_dest_leg} loading={loading} /></td>
                                    <td><strong>Dst Jitter:</strong> <Loading data={cdrData.jitter_on_dest_leg} loading={loading} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Dst Codec:</strong> <Loading data={cdrData.codec_on_dest_leg} loading={loading} /></td>
                                    <td><strong>Dst Latency:</strong> <Loading data={cdrData.latency_on_dest_leg} loading={loading} /></td>
                                    <td><strong>Dst R Factor:</strong> <Loading data={cdrData.rfactor_on_dest_leg} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><strong>Bytes fwd from Dst:</strong> <Loading data={cdrData.bytes_forwarded_from_dst} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>New From Uri User Part:</strong> <Loading data={cdrData.new_from_uri_user_part} loading={loading} /></td>
                                    <td colspan="2"><strong>New Paid Uri User Part:</strong> <Loading data={cdrData.new_paid_uri_user_part} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><strong>Request Uri User Part:</strong> <Loading data={cdrData.request_uri_user_part} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td><strong>Dst Policed Packets:</strong> <Loading data={cdrData.policed_packets_on_dest_leg} loading={loading} /></td>
                                    <td colspan="2"><strong>Dst Codec ptime:</strong> 0</td>
                                </tr>
                                <tr>
                                    <td rowspan="4"><strong>SRTP</strong></td>
                                    <td colspan="3"><strong>Dest Cipher Suite:</strong> <Loading data={cdrData.dest_cipher_suite} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><strong>Dest Packet Outside Replay Window:</strong> <Loading data={cdrData.dest_packet_outside_replay_window} loading={loading} /></td>
                                    
                                </tr>
                                <tr>
                                    <td colspan="3"><strong>Dest Packet Authentication Failure:</strong> <Loading data={cdrData.dest_packet_auth_failure} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><strong>Dest Packet Cipher Failure:</strong> <Loading data={cdrData.dest_packet_cipher_failure} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td rowspan="2"><strong>MSRP</strong></td>
                                    <td colspan="3"><strong>Msrp Data Volume Rx Dst:</strong> <Loading data={cdrData.msrp_data_volume_rx_dst} loading={loading} /></td>
                                </tr>
                                <tr>
                                    <td colspan="3"><strong>Msrp Im Rx Dst:</strong> <Loading data={cdrData.msrp_im_rx_dst} loading={loading} /></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VoiceCdrDetails;